// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import './assets/scss/swiper.css'
import 'iview/dist/styles/iview.css';
import './assets/scss/common.css'
import './assets/scss/default.min.css'
import  './assets/js/clipboard'
import http from './utils/http'
import check from './utils/check'
import iView from 'iview';
import store from './_vuex/store'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

if (!Vue.observable) {
  Vue.observable = function (obj) {
    return new Vue({
      data: obj
    }).$data;
  };
}

Vue.use(Antd);
Vue.use(iView);
Vue.config.productionTip = false
Vue.prototype.http = http;
Vue.prototype.check = check;

try {
  const currentUrl = window.location.href || window.location.toString();
  // sandbox: 开放平台预生产环境
  if (!currentUrl.includes('sandbox') && !currentUrl.includes('pre') && !currentUrl.includes('test') && !currentUrl.includes('localhost')) {
    const regex = /\b(?:\d{1,3}\.){3}\d{1,3}\b/;
    const ip = regex.test(currentUrl);
    if (!ip) {
      import('bw-front-logger').then(module => {
        const CollectErrors = module.default;
        const co = new CollectErrors({
          appId: 'yst-open' // 必填和发版平台模块名称保持一致
        });
      });
    }
  }
} catch (error) {
  console.log('error', error);
}

var vue = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});
Vue.prototype.http.initContext(vue);
Vue.prototype.check.initContext(vue);



// WEBPACK FOOTER //
// ./src/main.js